export default {
  'product.error.over_maximum_quantity': 'เกินจำนวนซื้อสูงสุดต่อครั้ง',
  'product.error.sold_out': 'สินค้ารายการนี้หมดแล้ว',
  'product.error.add_cart_fail': 'ไม่สามารถทำการเพิ่มสินค้าในตะกร้า',
  'product.available_store': 'ร้านค้าที่ร่วมรายการ',
  'product.all': 'ทั้งหมด',
  'product.introduction': 'รายละเอียดสินค้า',
  'product.discount_period': 'ระยะเวลาโปรโมชั่น',
  'product.sale_period': 'ระยะเวลาการขาย',
  'product.every_set': 'ต่อชุด',
  'product.piece': 'ชิ้น',
  'product.remain_count': 'จำนวนคงเหลือ',
  'product.limit_quantity': 'จำนวนที่สามารถซื้อได้',
  'product.limit_unit': 'ชุด',
  'product.notice': 'ข้อควรระวัง',
  'product.publisher.title': 'ข้อมูลผู้จัดจำหน่าย',
  'product.publisher.name': 'บริษัท รุ่ยติง ดิจิตอล จำกัด',
  'product.publisher.address': 'ที่อยู่: ชั้น 3 เลขที่ 25 ซอย 4 ถนน รินอาย เขตต้าอัน เมืองไทเป',
  'product.publisher.manager': 'ผู้จัดการ: เฉินเหยียนจาง',
  'product.publisher.tax_id': 'เลขประจำตัวผู้เสียภาษี: 42837620',
  'product.contract.title': 'การรับประกันการปฏิบัติตามสัญญา',
  'product.contract.content.one':
    'มูลค่าที่ได้รับจากการขายบัตรนี้ จะถูกฝากเข้าในบัญชีดูแลเฉพาะที่ธนาคารเยี่ยงฟง เพื่อให้ผู้จัดจำหน่ายใช้สำหรับการส่งมอบสินค้าหรือบริการที่กำหนดไว้เท่านั้น',
  'product.contract.content.two':
    'ระยะเวลาการเก็บรักษาเริ่มต้นจากวันที่จำหน่ายบัตรอิเล็กทรอนิกส์ (อ้างอิงจากวันที่ที่ระบุในบัตร) และจะมีระยะเวลา 1 ปี',
  'product.return_guide': 'นโยบายการคืนสินค้าและการขอเงินคืน',
  'product.shopping_guide': 'คู่มือการสั่งซื้อสินค้า',
  'product.expired': 'สินค้ารายการนี้หมดอายุแล้ว',
  'product.coming_soon': 'เตรียมวางจำหน่ายเร็ว ๆ นี้',
  'product.add_to_cart': 'เพิ่มลงในตะกร้า',
  'product.ok': 'ตกลง',
} as Record<string, string>;
